import React from 'react';
import classNames from 'classnames/bind';

// Components
import { Skeleton } from 'components';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const FamilyChildSkeleton = () => (
  <div className={cn('skeleton')}>
    <div className={cn('skeleton__title')}>
      <Skeleton />
    </div>
    <div className={cn('skeleton__cards')}>
      {Array.from(
        Array(3).keys(),
      ).map((skeleton) => (
        <div key={skeleton} className={cn('skeleton__card')}>
          <Skeleton />
        </div>
      ))}
    </div>
    <div className={cn('skeleton__button')}>
      <Skeleton />
    </div>
    <div className={cn('skeleton__questions-title')}>
      <Skeleton />
    </div>
    <div className={cn('skeleton__items')}>
      {Array.from(
        Array(5).keys(),
      ).map((skeleton) => (
        <div key={skeleton} className={cn('skeleton__item')}>
          <Skeleton />
        </div>
      ))}
    </div>
  </div>
);

export { FamilyChildSkeleton };
